<template>
  <div class="guide-wrapper">
    <div
      class="item"
      v-show="current === 0"
      :style="`background: top -11.73vw center / 100% url(${require(`@/images/novice-guide/guide-${navLangMain}-1.png`)}) no-repeat`"
    ></div>
    <div
      class="item"
      v-show="current === 1"
      :style="`background: top -36vw center / 100% url(${require(`@/images/novice-guide/guide-${navLangMain}-2.png`)}) no-repeat`"
    ></div>
    <div class="action-bar">
      <div class="btn row-center" @click="onBtnClick">
        <span v-if="!current">{{ $t('common.next') }}</span>
        <span v-else>{{ $t('common.start') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile';
import { mapState } from 'vuex';
export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      current: 0,
    };
  },
  computed: mapState(['navLangMain']),
  methods: {
    onBtnClick() {
      if (this.current === 0) {
        this.current = 1;
      } else if (this.current === 1) {
        this.$emit('completed');
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.guide-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #4d4d4d;
}

.item {
  position: relative;
  height: 100%;
}

.action-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: color-primary;

  .btn {
    margin: 4.8vw auto 9.6vw;
    width: 40.53vw;
    color: #fff;
    border: 0.27vw solid currentColor;
    min-height: 11.73vw;
    border-radius: 2.13vw;
    font-size: 4.27vw;
  }
}
</style>

